import React, { useEffect, useRef, useState } from 'react';
import { audio_settings } from '../audio_settings';

const SoundVideo = ({ paused = false, ...props }) => {
  const [sound, setSound] = useState(audio_settings.sound);
  const videoRef = useRef(null);

  useEffect(() => {
    const updateSound = (event) => {
      if (event.detail.name === 'sound') {
        setSound(event.detail.value);
      }
    };

    window.addEventListener('audio_setting_change', updateSound);
    return () => window.removeEventListener('audio_setting_change', updateSound);
  }, []);

  useEffect(() => {
    const video = videoRef.current;

    if (paused) {
      video.pause();
      return;
    }

    const playPromise = video.play();
    if (playPromise) {
      playPromise.catch(() => {});
    }
  }, [paused]);

  return <video ref={videoRef} {...props} muted={!sound} />;
};

export default SoundVideo;
